export default __webpack_public_path__ + "images/88aaa1afb363ba8a68083dd1271bdadc.svg";